export class CashEntryApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CashEntryApiError';
  }
}
